module.exports = __webpack_public_path__ + "static/media/alana.b33bf7e1.png";